import { showMsg } from "../actions/alertAction";
import * as sdk from "boa-sdk-ts";
import { WalletMessage } from "boa-sdk-ts";

export class ErrorCheckUtil {
  static dispatch;
  static t;
  static init = (dispatch, t) => {
    ErrorCheckUtil.dispatch = dispatch;
    ErrorCheckUtil.t = t;
  };
  static resCodeCheck = (res, isAlert = true) => {
    if (res.code === sdk.WalletResultCode.Success) {
      return true;
    } else {
      if (isAlert) {
        ErrorCheckUtil.dispatch(showMsg(ErrorCheckUtil.getLocaleMsg(res)));
      }
      return false;
    }
  };

  static convertMsg = (value) => {
    return ErrorCheckUtil.t(value);
  };

  static getLocaleMsg = (res) => {
    const { message } = res;
    if (message) {
      let value = "Not find locale message.";
      const key =
        Object.keys(WalletMessage)[
          Object.values(WalletMessage).indexOf(message)
        ];
      value = ErrorCheckUtil.t(key);
      return value;
    } else {
      return "";
    }
  };
}
